var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.903 9.316 19.348 0h-1.764l-6.465 8.089L5.955 0H0l7.808 12.231L0 22h1.764l6.828-8.542L14.044 22H20L11.902 9.316Zm-2.417 3.023-.791-1.218L2.4 1.43h2.71l5.08 7.82.791 1.219 6.604 10.166h-2.71L9.486 12.34Z",
    fill: "#fff"
  })));
};
export default SvgX;